var jade = require("/var/lib/jenkins-code/academia-app/node_modules/.pnpm/jade@1.11.0/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (actions, message, undefined) {
buf.push("<div class=\"top_banner_flash blue\"><i class=\"close\">×</i><div class=\"actions\">");
// iterate actions
;(function(){
  var $$obj = actions;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var action = $$obj[$index];

buf.push("<a" + (jade.attr("data-action", action, true, true)) + " class=\"action\">" + (jade.escape(null == (jade_interp = action) ? "" : jade_interp)) + "</a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var action = $$obj[$index];

buf.push("<a" + (jade.attr("data-action", action, true, true)) + " class=\"action\">" + (jade.escape(null == (jade_interp = action) ? "" : jade_interp)) + "</a>");
    }

  }
}).call(this);

buf.push("</div><p class=\"message\">" + (jade.escape(null == (jade_interp = message) ? "" : jade_interp)) + "</p></div>");}.call(this,"actions" in locals_for_with?locals_for_with.actions:typeof actions!=="undefined"?actions:undefined,"message" in locals_for_with?locals_for_with.message:typeof message!=="undefined"?message:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
}